import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Link } from '@coolblue-development/freddy';
import openAccountTrigger from '@coolblue-development/ga4-events/triggers/Account/openAccountTrigger';
import selectNavigationTrigger from '@coolblue-development/ga4-events/triggers/Account/selectNavigationTrigger';
import clickLogoutButtonTrigger from '@coolblue-development/ga4-events/triggers/Login/clickLogoutButtonTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { HeaderDropdown } from '@coolblue-development/next-patterns/client';
import { useTranslation } from '../../../i18n/useTranslation.js';
import AccountMenuIcon from '../AccountMenuIcon/AccountMenuIcon.js';
import FactSlogan from '../FactSlogan/FactSlogan.js';
import Login from '../Login/Login.js';
function Dropdown({ accountName, isCustomerRecognised, links, loginUrl }) {
    const { t } = useTranslation('account');
    const { trackEvent } = useAnalytics();
    const totalLinks = links.length;
    const trackLinkClick = (index, url, trackingRedirect, isLogout) => {
        if (isLogout) {
            trackEvent(clickLogoutButtonTrigger({
                sub_feature: 'header',
            }));
        }
        else {
            trackEvent(selectNavigationTrigger({
                index,
                total_indices: totalLinks,
                url,
                redirect: trackingRedirect,
            }));
        }
    };
    return (_jsxs(HeaderDropdown, { "aria-label": accountName ? t('myCoolblue') : t('login'), buttonChildren: _jsxs(_Fragment, { children: [_jsx(AccountMenuIcon, { isCustomerRecognised: isCustomerRecognised }), _jsx(Box, { hideUntil: "lg", children: accountName ? accountName : t('accountName') })] }), placement: "right", variant: accountName ? 'base' : 'wide', onOpen: () => trackEvent(openAccountTrigger({ sub_feature: 'header' })), children: [_jsx(FactSlogan, { isCustomerRecognised: isCustomerRecognised }), _jsx(Flex, { component: "ul", mt: 500, direction: "column", gap: 300, children: links.map((link, index) => link.url && (_jsx(Box, { component: "li", children: _jsx(Link, { href: link.url, onClick: () => {
                            var _a, _b;
                            return trackLinkClick(index, link.url, (_a = link.trackingRedirect) !== null && _a !== void 0 ? _a : '', (_b = link.isLogout) !== null && _b !== void 0 ? _b : false);
                        }, children: link.title }) }, link.title))) }), !isCustomerRecognised && loginUrl && _jsx(Login, { url: loginUrl })] }));
}
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map